export default defineNuxtPlugin({
  name: 'hydrated-client',
  setup() {
    onNuxtReady(() => {
      // Set attribute to flag when hydration process is over.
      document.getElementById('__nuxt')?.setAttribute('data-hydrated', '');
    });
  },
});
